// Pure decision for the wizard's inventory-feasibility advance gate, extracted
// so the "loading must not block" rule is unit-testable.
//
// The advance into the creative/review/pay steps (targetStep >= 3) is gated ONLY
// on a resolved *infeasible* verdict — NEVER on the transient *loading* state.
// Blocking on loading let a fast buyer who reached step 3 during the brief
// pre-request window get yanked back to step 2 the moment the in-flight check
// flipped `loading` true — an intermittent, network-dependent bounce that
// surfaced in a live demo and was unreproducible on a fast machine. (`loading`
// is taken as a parameter precisely so this test asserts it is ignored.)

export function shouldBlockAdvanceOnFeasibility(args: {
  /** The step the buyer is advancing to. */
  targetStep: number;
  /** Inventory check in flight (verdict not yet resolved). */
  loading: boolean;
  /** The resolved verdict says the campaign is infeasible. */
  infeasible: boolean;
}): boolean {
  if (args.targetStep < 3) return false;
  // Only a resolved infeasible verdict blocks; `loading` deliberately does not.
  return args.infeasible;
}
